/** @jsxRuntime classic */
/** @jsx jsx */

import SvgIcon from '@mui/material/SvgIcon';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import IconButton from '@mui/material/IconButton';
import Text from '@mui/material/Typography';

import { css, jsx } from '@emotion/react';
export default function DialogHeader({
  title,
  icon,
  onClose,
  noCloseButton = false,
}) {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 1rem;
        `}
      >
        {icon && (
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: center;
              width: 40px;
              height: 40px;

              background-color: var(--primary-8p);
              border-radius: 50%;
            `}
          >
            <SvgIcon component={icon} fontSize="medium" color="primary" />
          </div>
        )}
        <Text variant="subtitle1" fontWeight="600" color="textPrimary">
          {title}
        </Text>
      </div>
      {!noCloseButton && (
        <IconButton
          css={css`
            border: 1px solid rgba(0, 0, 0, 0.23);
            border-radius: 0.5rem;
          `}
          onClick={onClose}
          size="small"
        >
          <CloseOutlinedIcon />
        </IconButton>
      )}
    </div>
  );
}
